<table mat-table [dataSource]="dispositionData">
  <ng-container matColumnDef="purchaser">
    <th mat-header-cell *matHeaderCellDef="">Purchaser</th>
    <td mat-cell *matCellDef="let item">
      <ng-container
        *ngTemplateOutlet="
          valueSpan;
          context: {
            value: item.purchaser
          }
        ">
    </ng-container>
  </td>
</ng-container>
<ng-container matColumnDef="related_party">
  <th mat-header-cell *matHeaderCellDef="">Related Party</th>
  <td mat-cell *matCellDef="let item">
    <ng-container
      *ngTemplateOutlet="valueSpan; context: { value: item.related_party }">
    </ng-container>
  </td>
</ng-container>
<ng-container matColumnDef="disposition_type">
  <th mat-header-cell *matHeaderCellDef="">Type</th>
  <td mat-cell *matCellDef="let item">
    <ng-container
        *ngTemplateOutlet="
          valueSpan;
          context: { value: item.disposition_type }
        "></ng-container>
  </td>
</ng-container>
<ng-container matColumnDef="disposition_status">
  <th mat-header-cell *matHeaderCellDef="">Status</th>
  <td mat-cell *matCellDef="let item">
    <ng-container
        *ngTemplateOutlet="
          valueSpan;
          context: { value: item.disposition_status }
        "></ng-container>
  </td>
</ng-container>
<ng-container matColumnDef="monitoring_compliance">
  <th mat-header-cell *matHeaderCellDef="">Monitoring Compliance</th>
  <td mat-cell *matCellDef="let item">
    <ng-container
        *ngTemplateOutlet="
          valueSpan;
          context: { value: item.monitoring_compliance }
        ">
    </ng-container>
  </td>
</ng-container>
<ng-container matColumnDef="disposition_committee">
  <th mat-header-cell *matHeaderCellDef="">Disposition Committee</th>
  <td mat-cell *matCellDef="let item">
    <ng-container
        *ngTemplateOutlet="
          valueSpan;
          context: { value: item.disposition_committee }
        ">
    </ng-container>
  </td>
</ng-container>
<ng-container matColumnDef="closing_date">
  <th mat-header-cell *matHeaderCellDef="">Closing Date</th>
  <td mat-cell *matCellDef="let item">
    <ng-container
      *ngTemplateOutlet="valueSpan; context: { value: item.closing_date }">
    </ng-container>
  </td>
</ng-container>
<ng-container matColumnDef="board_consent_sent">
  <th mat-header-cell *matHeaderCellDef="">Board Consent Sent</th>
  <td mat-cell *matCellDef="let item">
    <ng-container
        *ngTemplateOutlet="
          valueSpan;
          context: { value: item.board_consent_sent }
        ">
    </ng-container>
  </td>
</ng-container>
<ng-container matColumnDef="board_consent_received">
  <th mat-header-cell *matHeaderCellDef="">Board Consent Received</th>
  <td mat-cell *matCellDef="let item">
    <ng-container
        *ngTemplateOutlet="
          valueSpan;
          context: { value: item.board_consent_received }
        ">
    </ng-container>
  </td>
</ng-container>
<ng-container matColumnDef="investor_consent_sent">
  <th mat-header-cell *matHeaderCellDef="">Investor Consent Sent</th>
  <td mat-cell *matCellDef="let item">
    <ng-container
        *ngTemplateOutlet="
          valueSpan;
          context: { value: item.investor_consent_sent }
        ">
    </ng-container>
  </td>
</ng-container>
<ng-container matColumnDef="investor_consent_received">
  <th mat-header-cell *matHeaderCellDef="">Investor Consent Received</th>
  <td mat-cell *matCellDef="let item">
    <ng-container
        *ngTemplateOutlet="
          valueSpan;
          context: { value: item.investor_consent_received }
        ">
    </ng-container>
  </td>
</ng-container>

<tr
  mat-header-row
  class="header"
*matHeaderRowDef="dispositionInfoColumns"></tr>
<tr mat-row *matRowDef="let items; columns: dispositionInfoColumns"></tr>
</table>
<ng-template let-value="value" #valueSpan>
  @if (value?.__typename) {
    <span>
      <contact-link [subject]="value"></contact-link>
    </span>
  } @else {
    @if (value?.length || value?.name?.length) {
      <span
        class="value"
        >{{ value?.name ? value.name : value }}</span
        >
      } @else {
        <span class="value">&mdash;</span>
      }
    }
  </ng-template>
